var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEv21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "3e00dee0-b1d4-4c5e-b814-f7179b6f9e22"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "46c6742e-6c31-4a99-ab3a-95394c650754"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03 0 0 0.03 541.2 541.2)",
    id: 36785
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(36.04 0 0 36.04 540 534.87)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-15.01, -15.12)",
    d: "M 27.94 11.75 C 26.93 11.75 26.09 12.48 25.91 13.44 L 21.48 14.29 C 21.11 13.709999999999999 20.47 13.319999999999999 19.740000000000002 13.319999999999999 C 18.610000000000003 13.319999999999999 17.700000000000003 14.229999999999999 17.680000000000003 15.349999999999998 L 14.330000000000004 16.58 C 13.950000000000003 16.15 13.410000000000004 15.879999999999999 12.790000000000003 15.879999999999999 C 12.610000000000003 15.879999999999999 12.430000000000003 15.909999999999998 12.270000000000003 15.959999999999999 L 10.400000000000002 13.41 C 10.600000000000001 13.09 10.730000000000002 12.71 10.730000000000002 12.3 C 10.730000000000002 11.16 9.810000000000002 10.24 8.670000000000002 10.24 C 7.530000000000001 10.24 6.610000000000001 11.16 6.610000000000001 12.3 C 6.610000000000001 12.46 6.630000000000001 12.610000000000001 6.660000000000001 12.75 L 3.270000000000001 15.03 C 2.940000000000001 14.799999999999999 2.530000000000001 14.66 2.100000000000001 14.66 C 0.95 14.66 0.03 15.58 0.03 16.72 C 0.03 17.86 0.9500000000000001 18.779999999999998 2.09 18.779999999999998 C 3.2299999999999995 18.779999999999998 4.15 17.859999999999996 4.15 16.72 C 4.15 16.56 4.130000000000001 16.41 4.1000000000000005 16.27 L 7.49 13.99 C 7.82 14.22 8.23 14.36 8.66 14.36 C 8.84 14.36 9.02 14.33 9.18 14.28 L 11.05 16.83 C 10.850000000000001 17.15 10.72 17.529999999999998 10.72 17.939999999999998 C 10.72 19.08 11.64 19.999999999999996 12.780000000000001 19.999999999999996 C 13.920000000000002 19.999999999999996 14.82 19.099999999999998 14.840000000000002 17.979999999999997 L 18.19 16.749999999999996 C 18.57 17.179999999999996 19.110000000000003 17.449999999999996 19.73 17.449999999999996 C 20.740000000000002 17.449999999999996 21.580000000000002 16.719999999999995 21.76 15.759999999999996 L 26.19 14.909999999999997 C 26.560000000000002 15.489999999999997 27.200000000000003 15.879999999999997 27.93 15.879999999999997 C 29.07 15.879999999999997 29.99 14.959999999999997 29.99 13.819999999999997 C 29.99 12.679999999999996 29.069999999999997 11.759999999999996 27.93 11.759999999999996 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(36.04 0 0 36.04 190.01 885.41)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2.62, -24.55)",
    d: "M 4.9 26.1 C 4.9 26.73 4.67 27.23 4.220000000000001 27.59 C 3.7700000000000005 27.95 3.130000000000001 28.14 2.3200000000000007 28.14 C 1.5700000000000007 28.14 0.9100000000000008 28 0.34000000000000075 27.72 L 0.34000000000000075 26.34 C 0.8100000000000007 26.55 1.2100000000000009 26.7 1.5400000000000007 26.79 C 1.8700000000000008 26.88 2.170000000000001 26.919999999999998 2.440000000000001 26.919999999999998 C 2.770000000000001 26.919999999999998 3.0100000000000007 26.86 3.190000000000001 26.729999999999997 C 3.3600000000000008 26.609999999999996 3.450000000000001 26.419999999999998 3.450000000000001 26.179999999999996 C 3.450000000000001 26.039999999999996 3.410000000000001 25.919999999999995 3.340000000000001 25.809999999999995 C 3.260000000000001 25.699999999999996 3.1500000000000012 25.599999999999994 3.0000000000000013 25.499999999999996 C 2.8500000000000014 25.4 2.550000000000001 25.239999999999995 2.090000000000001 25.029999999999998 C 1.6600000000000013 24.83 1.3400000000000012 24.639999999999997 1.1300000000000012 24.45 C 0.9200000000000013 24.27 0.7500000000000012 24.05 0.6200000000000012 23.8 C 0.4900000000000012 23.55 0.4300000000000012 23.27 0.4300000000000012 22.94 C 0.4300000000000012 22.32 0.6400000000000012 21.830000000000002 1.0600000000000012 21.48 C 1.480000000000001 21.13 2.0600000000000014 20.95 2.800000000000001 20.95 C 3.160000000000001 20.95 3.510000000000001 20.99 3.840000000000001 21.08 C 4.170000000000002 21.169999999999998 4.520000000000001 21.29 4.880000000000001 21.439999999999998 L 4.4 22.589999999999996 C 4.03 22.439999999999998 3.72 22.329999999999995 3.47 22.269999999999996 C 3.22 22.209999999999997 2.99 22.179999999999996 2.75 22.179999999999996 C 2.4699999999999998 22.179999999999996 2.25 22.249999999999996 2.1 22.379999999999995 C 1.9500000000000002 22.509999999999994 1.87 22.679999999999996 1.87 22.889999999999997 C 1.87 23.019999999999996 1.9000000000000001 23.129999999999995 1.9600000000000002 23.229999999999997 C 2.02 23.33 2.12 23.419999999999998 2.25 23.509999999999998 C 2.38 23.599999999999998 2.7 23.759999999999998 3.19 23.999999999999996 C 3.84 24.309999999999995 4.29 24.629999999999995 4.53 24.939999999999998 C 4.7700000000000005 25.249999999999996 4.890000000000001 25.639999999999997 4.890000000000001 26.099999999999998 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(36.04 0 0 36.04 388.11 885.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-8.12, -24.55)",
    d: "M 8.86 28.05 L 7.379999999999999 28.05 L 7.379999999999999 22.29 L 5.479999999999999 22.29 L 5.479999999999999 21.06 L 10.759999999999998 21.06 L 10.759999999999998 22.29 L 8.859999999999998 22.29 L 8.859999999999998 28.049999999999997 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(36.04 0 0 36.04 261.54 189.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-7.19, -5.36)",
    d: "M 7.93 8.85 L 6.449999999999999 8.85 L 6.449999999999999 3.09 L 4.549999999999999 3.09 L 4.549999999999999 1.8599999999999999 L 9.829999999999998 1.8599999999999999 L 9.829999999999998 3.09 L 7.929999999999998 3.09 L 7.929999999999998 8.85 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(36.04 0 0 36.04 496.39 190.11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-13.7, -5.36)",
    d: "M 12.39 6.17 L 12.39 8.85 L 10.91 8.85 L 10.91 1.86 L 12.95 1.86 C 13.899999999999999 1.86 14.6 2.0300000000000002 15.059999999999999 2.38 C 15.52 2.73 15.739999999999998 3.25 15.739999999999998 3.96 C 15.739999999999998 4.37 15.629999999999999 4.74 15.399999999999999 5.0600000000000005 C 15.169999999999998 5.380000000000001 14.849999999999998 5.630000000000001 14.439999999999998 5.8100000000000005 C 15.489999999999998 7.380000000000001 16.179999999999996 8.4 16.499999999999996 8.86 L 14.849999999999996 8.86 L 13.179999999999996 6.18 L 12.389999999999997 6.18 Z M 12.39 4.96 L 12.870000000000001 4.96 C 13.340000000000002 4.96 13.680000000000001 4.88 13.91 4.7299999999999995 C 14.139999999999999 4.579999999999999 14.24 4.329999999999999 14.24 3.9899999999999993 C 14.24 3.6499999999999995 14.13 3.4199999999999995 13.9 3.2799999999999994 C 13.67 3.1399999999999992 13.32 3.0699999999999994 12.84 3.0699999999999994 L 12.39 3.0699999999999994 L 12.39 4.959999999999999 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(36.04 0 0 36.04 655.21 189.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-18.12, -5.35)",
    d: "M 17.38 8.85 L 17.38 1.86 L 18.86 1.86 L 18.86 8.85 L 17.38 8.85 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(36.04 0 0 36.04 851.34 883.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-23.03, -5.36)",
    d: "M 25.45 4.04 C 25.45 4.79 25.21 5.37 24.74 5.77 C 24.27 6.17 23.599999999999998 6.369999999999999 22.729999999999997 6.369999999999999 L 22.089999999999996 6.369999999999999 L 22.089999999999996 8.86 L 20.609999999999996 8.86 L 20.609999999999996 1.86 L 22.839999999999996 1.86 C 23.689999999999998 1.86 24.329999999999995 2.04 24.779999999999998 2.41 C 25.22 2.7800000000000002 25.439999999999998 3.3200000000000003 25.439999999999998 4.04 Z M 22.099999999999998 5.15 L 22.589999999999996 5.15 C 23.049999999999997 5.15 23.389999999999997 5.0600000000000005 23.609999999999996 4.880000000000001 C 23.839999999999996 4.700000000000001 23.949999999999996 4.44 23.949999999999996 4.090000000000001 C 23.949999999999996 3.740000000000001 23.859999999999996 3.4900000000000007 23.669999999999995 3.3200000000000007 C 23.479999999999993 3.150000000000001 23.179999999999996 3.0700000000000007 22.779999999999994 3.0700000000000007 L 22.109999999999992 3.0700000000000007 L 22.109999999999992 5.15 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(36.04 0 0 36.04 832.42 190.11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-23.03, -5.36)",
    d: "M 25.45 4.04 C 25.45 4.79 25.21 5.37 24.74 5.77 C 24.27 6.17 23.599999999999998 6.369999999999999 22.729999999999997 6.369999999999999 L 22.089999999999996 6.369999999999999 L 22.089999999999996 8.86 L 20.609999999999996 8.86 L 20.609999999999996 1.86 L 22.839999999999996 1.86 C 23.689999999999998 1.86 24.329999999999995 2.04 24.779999999999998 2.41 C 25.22 2.7800000000000002 25.439999999999998 3.3200000000000003 25.439999999999998 4.04 Z M 22.099999999999998 5.15 L 22.589999999999996 5.15 C 23.049999999999997 5.15 23.389999999999997 5.0600000000000005 23.609999999999996 4.880000000000001 C 23.839999999999996 4.700000000000001 23.949999999999996 4.44 23.949999999999996 4.090000000000001 C 23.949999999999996 3.740000000000001 23.859999999999996 3.4900000000000007 23.669999999999995 3.3200000000000007 C 23.479999999999993 3.150000000000001 23.179999999999996 3.0700000000000007 22.779999999999994 3.0700000000000007 L 22.109999999999992 3.0700000000000007 L 22.109999999999992 5.15 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.45 0 0 50.45 609.53 885.28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-21.91, -15)",
    d: "M 19.56 15 C 19.56 14.76 19.59 14.53 19.639999999999997 14.3 C 19.699999999999996 14.08 19.769999999999996 13.870000000000001 19.879999999999995 13.680000000000001 C 19.989999999999995 13.490000000000002 20.099999999999994 13.310000000000002 20.249999999999996 13.150000000000002 C 20.389999999999997 12.990000000000002 20.549999999999997 12.860000000000003 20.729999999999997 12.740000000000002 C 20.909999999999997 12.620000000000001 21.089999999999996 12.540000000000003 21.289999999999996 12.480000000000002 C 21.489999999999995 12.420000000000002 21.699999999999996 12.390000000000002 21.919999999999995 12.390000000000002 C 22.139999999999993 12.390000000000002 22.339999999999996 12.420000000000002 22.539999999999996 12.480000000000002 C 22.739999999999995 12.540000000000003 22.929999999999996 12.630000000000003 23.099999999999994 12.740000000000002 C 23.269999999999992 12.850000000000001 23.429999999999993 12.990000000000002 23.579999999999995 13.150000000000002 C 23.719999999999995 13.310000000000002 23.849999999999994 13.480000000000002 23.949999999999996 13.680000000000001 C 24.049999999999997 13.870000000000001 24.129999999999995 14.080000000000002 24.189999999999994 14.3 C 24.249999999999993 14.52 24.269999999999992 14.760000000000002 24.269999999999992 15 C 24.269999999999992 15.239999999999998 24.23999999999999 15.48 24.189999999999994 15.7 C 24.139999999999997 15.919999999999998 24.049999999999994 16.13 23.949999999999996 16.32 C 23.849999999999994 16.51 23.719999999999995 16.69 23.579999999999995 16.85 C 23.439999999999994 17.01 23.279999999999994 17.14 23.099999999999994 17.26 C 22.929999999999993 17.37 22.739999999999995 17.46 22.539999999999996 17.520000000000003 C 22.339999999999996 17.580000000000002 22.129999999999995 17.610000000000003 21.919999999999995 17.610000000000003 C 21.709999999999994 17.610000000000003 21.489999999999995 17.580000000000002 21.289999999999996 17.520000000000003 C 21.089999999999996 17.460000000000004 20.899999999999995 17.370000000000005 20.729999999999997 17.26 C 20.559999999999995 17.150000000000002 20.4 17.01 20.249999999999996 16.85 C 20.109999999999996 16.69 19.979999999999997 16.520000000000003 19.879999999999995 16.32 C 19.779999999999994 16.119999999999997 19.699999999999996 15.92 19.639999999999997 15.700000000000001 C 19.58 15.48 19.56 15.24 19.56 15.000000000000002 Z M 20.349999999999998 15 C 20.349999999999998 15.26 20.389999999999997 15.5 20.47 15.72 C 20.549999999999997 15.940000000000001 20.66 16.13 20.799999999999997 16.3 C 20.939999999999998 16.46 21.099999999999998 16.59 21.289999999999996 16.68 C 21.479999999999993 16.77 21.679999999999996 16.82 21.889999999999997 16.82 C 22.099999999999998 16.82 22.31 16.77 22.499999999999996 16.68 C 22.689999999999998 16.59 22.849999999999998 16.46 22.989999999999995 16.3 C 23.129999999999995 16.14 23.239999999999995 15.950000000000001 23.319999999999993 15.72 C 23.39999999999999 15.5 23.439999999999994 15.26 23.439999999999994 15 C 23.439999999999994 14.74 23.399999999999995 14.5 23.319999999999993 14.28 C 23.23999999999999 14.059999999999999 23.129999999999992 13.86 22.989999999999995 13.7 C 22.849999999999994 13.54 22.679999999999996 13.41 22.499999999999996 13.319999999999999 C 22.309999999999995 13.229999999999999 22.109999999999996 13.179999999999998 21.889999999999997 13.179999999999998 C 21.669999999999998 13.179999999999998 21.469999999999995 13.229999999999999 21.289999999999996 13.319999999999999 C 21.099999999999994 13.409999999999998 20.939999999999994 13.54 20.799999999999997 13.7 C 20.659999999999997 13.86 20.549999999999997 14.059999999999999 20.47 14.28 C 20.39 14.5 20.349999999999998 14.74 20.349999999999998 15 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEv21);
export default __webpack_public_path__ + "static/media/EV21.6ed61451803da286696e2ca4dea4249f.svg";
export { ForwardRef as ReactComponent };